import React from 'react';
import { motion } from 'framer-motion';
import { Bot, Network, FileCheck, ArrowRight } from 'lucide-react';
export function Slide11SponsrAI() {
  const features = [{
    icon: Bot,
    title: 'AI Matching',
    desc: 'Connects brands & organizers'
  }, {
    icon: FileCheck,
    title: 'Automation',
    desc: 'Contracts & activation flows'
  }, {
    icon: Network,
    title: 'Funnel Filling',
    desc: 'New brands constantly added'
  }, {
    icon: ArrowRight,
    title: 'Conversion',
    desc: 'Leads to digital & physical sampling'
  }];
  return <div className="flex flex-col h-full justify-center max-w-6xl mx-auto w-full" data-id="element-146">
      <motion.h2 className="text-5xl font-bold text-[#ffd700] mb-20 text-center" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} data-id="element-147">
        SponsrAI
      </motion.h2>

      <div className="relative" data-id="element-148">
        {/* Background Network Animation */}
        <div className="absolute inset-0 flex items-center justify-center opacity-20" data-id="element-149">
          <motion.div className="w-[600px] h-[600px] border border-[#ffd700] rounded-full" animate={{
          scale: [1, 1.2, 1],
          rotate: 360
        }} transition={{
          duration: 20,
          repeat: Infinity,
          ease: 'linear'
        }} data-id="element-150" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 relative z-10" data-id="element-151">
          {features.map((feature, i) => <motion.div key={i} initial={{
          scale: 0.8,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} transition={{
          delay: i * 0.2
        }} className="bg-white/5 backdrop-blur-sm border border-white/10 p-8 rounded-2xl hover:border-[#ffd700]/50 transition-colors" data-id="element-152">
              <feature.icon className="w-10 h-10 text-[#ffd700] mb-4" data-id="element-153" />
              <h3 className="text-2xl font-bold text-white mb-2" data-id="element-154">
                {feature.title}
              </h3>
              <p className="text-white/70 text-lg" data-id="element-155">{feature.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </div>;
}